import React from "react";
import { useHistory } from "react-router-dom";
import { Search } from "react-bootstrap-icons";
import SelectCustom from "../common/SelectCustom";
import BannerImage from "../../gallery/banner.jpg";
// import { useQuery } from "react-query";
// import axios from "axios";

const EventsBanner = React.memo(function EventsBanner({ locations }) {
  let locationSelectedOption = {
    label: "Chose your location",
    value: 1,
  };

  const history = useHistory();

  const handleRedirect = (e) => {
    e.preventDefault();
    let location_id = 1;

    var locSelect = document.getElementById("location_select");
    if (locSelect.title !== "") {
      location_id = locSelect.title;
    }
    history.push(`/search?category=4&location=${location_id}&page=1&limit=10`);
  };
  // If locations are not loaded yet, show skeleton
  if (!locations) {
    return (
      <>
        <div className="container-fluid">
          <section className="hero hero--video">
            <div className="container">
              <div className="col-12">
                <div className="search">
                  <h6 className="banner-text-1">जे खोजिन्छ, मज्जाले भेटिन्छ</h6>
                  <h6 className="banner-text-2">Find Nepalese events in your city</h6>
                  <div className="row">
                    <div className="col-lg-4 col-md-3 hidden-mobile"></div>
                    <div className="col-lg-3 col-md-4 col-12 location-select">
                      <div
                        style={{
                          height: "38px",
                          border: "1px solid #ced4da",
                          borderRadius: "0.375rem",
                          backgroundColor: "#fff",
                          display: "flex",
                          alignItems: "center",
                          padding: "0.375rem 0.75rem",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <div
                            style={{
                              height: "1.2em",
                              backgroundColor: "#f0f0f0",
                              borderRadius: "4px",
                            }}
                          ></div>
                        </div>
                        <div
                          style={{
                            width: "0",
                            height: "0",
                            borderLeft: "0.3em solid transparent",
                            borderRight: "0.3em solid transparent",
                            borderTop: "0.3em solid #495057",
                            marginLeft: "auto",
                          }}
                        ></div>
                      </div>
                    </div>
                    <div className="col-lg-1 col-md-2 col-12">
                      <div
                        style={{
                          height: "38px",
                          backgroundColor: "#dc3545",
                          border: "1px solid #dc3545",
                          borderRadius: "0.375rem",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#fff",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          animation: "pulse 1.5s ease-in-out infinite",
                          marginTop: "4px",
                        }}
                      >
                        <div
                          style={{
                            width: "16px",
                            height: "16px",
                            backgroundColor: "rgba(255,255,255,0.3)",
                            borderRadius: "50%",
                            marginRight: "8px",
                          }}
                        ></div>
                        <div
                          style={{
                            height: "1em",
                            width: "40px",
                            backgroundColor: "rgba(255,255,255,0.3)",
                            borderRadius: "4px",
                          }}
                        ></div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-3 hidden-mobile"></div>
                  </div>
                </div>
              </div>
            </div>
            <img className="d-lg-block" src={BannerImage} alt="Banner" style={{ opacity: "0.3" }} />
          </section>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="container-fluid">
        <section className="hero hero--video">
          <div className="container">
            <div className="col-12">
              <div className="search">
                <h6 className="banner-text-1">जे खोजिन्छ, मज्जाले भेटिन्छ</h6>
                <h6 className="banner-text-2">Find Nepalese events in your city</h6>
                <div className="row">
                  <div className="col-lg-4 col-md-3 hidden-mobile"></div>
                  {locations && (
                    <div className="col-lg-3 col-md-4 col-12 location-select">
                      <SelectCustom
                        id={"location_select"}
                        //placeHolder='Town or City'
                        options={locations}
                        selectedOption={locationSelectedOption}
                      />
                    </div>
                  )}
                  <div className="col-lg-1 col-md-2 col-12">
                    <button onClick={handleRedirect} className="btn-search-danger">
                      <Search size={15} style={{ marginRight: "5px" }} />
                      Search
                    </button>
                  </div>
                  <div className="col-lg-4 col-md-3 hidden-mobile"></div>
                </div>
              </div>
            </div>
          </div>
          <img className="d-lg-block" src={BannerImage} alt="Banner" style={{ opacity: "0.3" }} />
        </section>
      </div>
    </>
  );
});

export default EventsBanner;
